module.exports = __webpack_public_path__ + "static/media/9.5cc20f98.jpg";